import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";

const CalendarInputDay = ({
  day,
  value: initialValue,
  onChange = console.log
}) => {
  const [value, setValue] = useState("");

  const classList = [
    "calendar-day",
    day.isSame(moment(), "day") ? "is-same-day" : "",
    day.isSame(moment(), "month") ? "is-same-month" : ""
  ].join(" ");

  const handleChange = e => {
    // REGEX TO MATCH EMPTY STRING OR NUMBERS
    if (/(^\d+$)|(^$)/.test(e.target.value)) {
      setValue(e.target.value);
    }
  };
  const handleBlur = () => {
    onChange(day, value);
  };
  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
    }
  }, [initialValue]);
  return (
    <div className={classList}>
      <span>{day.format("DD")}</span>
      <input
        type="text"
        value={value}
        onBlur={handleBlur}
        onChange={handleChange}
      />
    </div>
  );
};

CalendarInputDay.propTypes = {
  value: PropTypes.string,
  day: PropTypes.instanceOf(moment).isRequired,
  onChange: PropTypes.func
};

export default CalendarInputDay;
